import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 group">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg transition-transform duration-300 group-hover:scale-110">
                <i className="ri-play-circle-fill text-xl text-background-50"></i>
              </div>
              <span className="text-xl font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>
                {t('site.name')}
              </span>
            </Link>
            <p className="text-secondary-400 text-sm leading-relaxed max-w-md">
              {t('site.description')}
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-300 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-300 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-300 cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm" style={{ fontFamily: 'var(--font-heading)' }}>快速导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-secondary-400 hover:text-background-50 text-sm transition-colors duration-200">{t('nav.home')}</Link>
              </li>
              <li>
                <Link to="/category/all" className="text-secondary-400 hover:text-background-50 text-sm transition-colors duration-200">{t('category.title')}</Link>
              </li>
              <li>
                <Link to="/about" className="text-secondary-400 hover:text-background-50 text-sm transition-colors duration-200">{t('nav.about')}</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm" style={{ fontFamily: 'var(--font-heading)' }}>热门分类</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/category/movie" className="text-secondary-400 hover:text-background-50 text-sm transition-colors duration-200">{t('category.movie')}</Link>
              </li>
              <li>
                <Link to="/category/tv" className="text-secondary-400 hover:text-background-50 text-sm transition-colors duration-200">{t('category.tv')}</Link>
              </li>
              <li>
                <Link to="/category/variety" className="text-secondary-400 hover:text-background-50 text-sm transition-colors duration-200">{t('category.variety')}</Link>
              </li>
              <li>
                <Link to="/category/anime" className="text-secondary-400 hover:text-background-50 text-sm transition-colors duration-200">{t('category.anime')}</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-secondary-500 text-xs">
            &copy; {currentYear} {t('site.name')} - {t('footer.copyright')}
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-secondary-500 hover:text-secondary-300 text-xs transition-colors duration-200">{t('footer.terms')}</a>
            <a href="#" className="text-secondary-500 hover:text-secondary-300 text-xs transition-colors duration-200">{t('footer.privacy')}</a>
            <a href="#" className="text-secondary-500 hover:text-secondary-300 text-xs transition-colors duration-200">{t('footer.help')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;